export var LOCAL_STORAGE_KEY = {
    ACCESS_TOKEN: 'accessToken',
    AFTER_LOGIN_PATH: 'afterLoginPath',
};
